class CellSlideshow {
  constructor(el) {
    this.index = 0
    this.dots = el.querySelector('.dots')
    this.slider = el.querySelector('.slider')
    this.slides = this.slider.querySelectorAll('.paragraph--type--cell-slide')
    this.prevBtn = el.querySelector('.nav-buttons .prev')
    this.nextBtn = el.querySelector('.nav-buttons .next')

    // Set initial widths
    this.slider.style.width = (this.slides.length * 100) + '%'
    this.slides.forEach((slide, idx) => {
      slide.style.width = (100 / this.slides.length) + '%'

      // Add a dot
      let li = document.createElement('li')
      li.appendChild(document.createTextNode('•'))

      li.addEventListener('click', e => {
        this.goto(idx)
      })

      this.dots.appendChild(li)
    })

    this.dots.querySelectorAll('li')[this.index].classList.add('active')
    this.prevBtn.addEventListener('click', () => {
      this.prev();
    });
    this.nextBtn.addEventListener('click', () => {
      this.next();
    });
    // go to first slide to trigger any button states
    this.goto(0);
    // Auto Advance slideshow
    // this.autoAdvance()
  }

  next() {
    let idx = this.index + 1

    if (idx === this.slides.length) {
      idx = 0
    }

    this.goto(idx)
  }

  prev() {
    let idx = this.index - 1

    if (idx < 0) {
      idx = this.slides.length - 1
    }

    this.goto(idx)
  }

  goto(idx) {
    const dots = this.dots.querySelectorAll('li')
    dots[this.index].classList.remove('active')
    dots[idx].classList.add('active')
    this.slider.style.marginLeft = (-100 * idx) + '%'

    if (idx === this.slides.length - 1) {
      this.nextBtn.classList.add('disabled');
    } else {
      this.nextBtn.classList.remove('disabled');
    }
    if (idx === 0) {
      this.prevBtn.classList.add('disabled');
    } else {
      this.prevBtn.classList.remove('disabled');
    }
    this.index = idx
    // this.autoAdvance()
  }

  autoAdvance() {
    if (typeof this.timer !== 'undefined') {
      clearInterval(this.timer)
    }

    this.timer = setInterval(() => {
      this.next()
    }, 8000)
  }
}

export default CellSlideshow


// WEBPACK FOOTER //
// ./js/classes/cell-slideshow.class.js